export type CategorizedStock<T> = {
  vegetable: T[];
  agroforestry: T[];
};

export const splitStockByCategory = <T>(
  rows: T[],
  isAgroforestry: (row: T) => boolean
): CategorizedStock<T> => {
  return rows.reduce<CategorizedStock<T>>(
    (acc, row) => {
      if (isAgroforestry(row)) {
        acc.agroforestry.push(row);
      } else {
        acc.vegetable.push(row);
      }
      return acc;
    },
    { vegetable: [], agroforestry: [] }
  );
};
